import React from 'react';
import { OBSERVATION_STAGE_META } from '@/lib/format2';

export function ObservationStageBadge({ stage, testId }) {
  const meta = OBSERVATION_STAGE_META[stage] || OBSERVATION_STAGE_META['AI Observation'];
  return (
    <span
      data-testid={testId || 'observation-stage'}
      className="inline-flex items-center gap-1.5 rounded-full text-[10px] px-2 py-0.5 uppercase tracking-wide font-medium border"
      style={{ color: meta.color, borderColor: `${meta.color}55`, background: `${meta.color}12` }}
      title={meta.hint}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.color }} />
      {stage}
    </span>
  );
}
